import { useEffect} from 'react';
import ReactDOM from 'react-dom';
import Chat from './Chat';

const ChatWindowed = () => {

  useEffect(() => {
    document.getElementsByTagName('html')[0].style.height = 'auto';
  }, []);

  return ReactDOM.createPortal(
    <Chat windowed={true} />,
    document.getElementById('root') as HTMLElement,
  );
};

export default ChatWindowed;
